export const queryPage = '/icps/system/sign/cloudSell/engineeringManagement/other/payee/queryPage'
export const Download = '/icps/system/sign/cloudSell/engineeringManagement/other/payee/exportOtherPayee'
export const deleteNotes = '/icps/system/sign/cloudSell/engineeringManagement/other/payee/batchDelete'
import request from '@/utils/request'
export function get_list_by_type(data) {
    return request({
        url: '/base/system/base/organization/get_list_by_type',
        method: 'get',
        params: data
    })
}
export function queryEngineering(data) {
    return request({
        url: '/icps/system/sign/cloudSell/notes/queryEngineering',
        method: 'get',
        params: data
    })
}
export function getOtherBill(data) {
    return request({
        url: '/icps/system/sign/cloudSell/engineeringManagement/other/payee/getOtherBill',
        method: 'get',
        params: data
    })
}
export function queryPageTicket(data) {
    return request({
        url: '/icps/system/sign/cloudSell/collectMoney/queryPage',
        method: 'POST',
        data
    })
}
export function queryPageOtherTicket(data) {
    return request({
        url: '/icps/system/sign/cloudSell/engineeringManagement/other/payee/queryPage',
        method: 'POST',
        data
    })
}
export function get_detail_code(data) {
    return request({
        url: '/base/system/base/dictionary/get_detail_codes',
        method: 'get',
        params: data
    })
}
export function saveOrUpdate(data) {
    return request({
        url: '/icps/system/sign/cloudSell/engineeringManagement/other/payee/saveOrUpdate',
        method: 'POST',
        data
    })
}
export function deletePayUnit(data) {
    return request({
        url: '/icps/system/sign/cloudSell/payerUnitManage/deletePayUnit',
        method: 'POST',
        data
    })
}